import { Card, CardContent } from "@/components/ui/card";
import { Construction } from "lucide-react";

export default function PlaceholderPage({ title, description }) {
  return (
    <div className="max-w-2xl" data-testid="placeholder-page">
      <Card className="border-dashed border-2 border-slate-300 bg-white">
        <CardContent className="p-10 flex flex-col items-center text-center">
          <div className="h-14 w-14 rounded-full bg-sky-50 flex items-center justify-center mb-4">
            <Construction className="h-7 w-7 text-[#4FA3D1]" />
          </div>
          <h3 className="text-xl font-bold text-slate-900">{title}</h3>
          <p className="text-sm text-slate-500 mt-2 max-w-md">
            {description || "This module is part of a later phase. We'll surface live data here as soon as it's enabled."}
          </p>
          <span className="mt-4 inline-flex items-center gap-2 rounded-full bg-amber-100 text-amber-800 text-xs font-medium px-3 py-1">
            Coming in next phase
          </span>
        </CardContent>
      </Card>
    </div>
  );
}
